export default "__VITE_ASSET__UOE9XBu7__"